import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EvaluatedAttributeListItemComponent from './EvaluatedAttributeListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const EvaluatedAttributeListComponent = ({ attributes, isReadOnly, dispatch }) => {
  const { t } = useTranslation();
  return (
    <CardNoResultsWrapper content={attributes}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('EngineScoring.EvaluatedAttributes.OrderNo')}</TableCell>
            <TableCell>{t('EngineScoring.EvaluatedAttributes.Name')}</TableCell>
            <TableCell>{t('EngineScoring.EvaluatedAttributes.Description')}</TableCell>
            <TableCell>{t('EngineScoring.EvaluatedAttributes.Expression')}</TableCell>
            <TableCell>{t('EngineScoring.EvaluatedAttributes.ExecutionGroup')}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {attributes.map((item, idx) => {
            return <EvaluatedAttributeListItemComponent key={idx} item={item} index={idx} dispatch={dispatch} isReadOnly={isReadOnly} />;
          })}
        </TableBody>
      </Table>
    </CardNoResultsWrapper>
  );
};

EvaluatedAttributeListComponent.propTypes = {
  attributes: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool,
  dispatch: PropTypes.func.isRequired
};

export default EvaluatedAttributeListComponent;
